module.exports = __webpack_public_path__ + "img/icon-printer.75b9cae1.svg";